import service from "../services/settings.service";

export const settings = {
    namespaced: true,
    state: {
        settings: null,
    },
    getters: {
        manageProduction: (state) => {
            if (!state.settings || state.settings.manage_production === undefined || state.settings.manage_production === null) {
                return true;
            }
            return !!state.settings.manage_production;
        },
        siigoSyncEnabled: (state) => {
            if (!state.settings || state.settings.siigo_sync_enabled === undefined || state.settings.siigo_sync_enabled === null) {
                return false;
            }
            const value = state.settings.siigo_sync_enabled;
            return value !== false && value !== 0 && value !== '0';
        },
        miaAgentEnabled: (state) => {
            if (!state.settings || state.settings.mia_agent_enabled === undefined || state.settings.mia_agent_enabled === null) {
                return false;
            }
            const value = state.settings.mia_agent_enabled;
            return value !== false && value !== 0 && value !== '0';
        },
        conenviosEnabled: (state) => {
            if (!state.settings || state.settings.conenvios_enabled === undefined || state.settings.conenvios_enabled === null) {
                return false;
            }
            const value = state.settings.conenvios_enabled;
            return value !== false && value !== 0 && value !== '0';
        },
    },
    actions: {
        async get({ commit }, data) {
            try {
                const response = await service.get(data);
                commit("SET_SETTINGS", response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async save({ commit }, data) {
            try {
                const response = await service.updateData(data);
                commit("SET_SETTINGS", response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_SETTINGS(state, settings) {
            state.settings = settings;
        },
    },
};
